import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import _ from 'lodash';
import { setCurrentWorkspaceEventsIds } from '../slices/currentWorkspace';
import { setEvents } from '../slices/events';

export const getEventsByWorkspace = createAsyncThunk(
  'brands/getEventsByWorkspace',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;
    if (!_.isEmpty(workspaceId)) {
      setLoading(true);
      try {
        const events = await api.workspace.getEventsByWorkspaceId({
          workspaceId,
        });

        if (events.data.getEventsByWorkspaceId?.events) {
          dispatch(setEvents(events.data.getEventsByWorkspaceId.events));

          dispatch(
            setCurrentWorkspaceEventsIds(
              events.data.getEventsByWorkspaceId.events.map(
                (events) => events.id
              )
            )
          );
        }
        setLoading(false);
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
      }
    } else {
      setErrors('generalError');
      setLoading(false);
    }
  }
);

export const getEventsByWorkspaceAndProtocol = createAsyncThunk(
  'brands/getEventsByWorkspaceAndProtocol',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      protocolId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;
    if (!_.isEmpty(workspaceId) && !_.isEmpty(protocolId)) {
      setLoading(true);
      try {
        const events = await api.workspace.getEventsByWorkspaceIdAndProtocolId({
          workspaceId,
          protocolId,
        });
        if (events.data.getEventsByWorkspaceIdAndProtocolId?.events) {
          dispatch(
            setEvents(events.data.getEventsByWorkspaceIdAndProtocolId.events)
          );

          dispatch(
            setCurrentWorkspaceEventsIds(
              events.data.getEventsByWorkspaceIdAndProtocolId.events.map(
                (events) => events.id
              )
            )
          );
        }
        setLoading(false);
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
      }
    } else {
      setErrors('generalError');
      setLoading(false);
    }
  }
);

export const createEvent = createAsyncThunk(
  'events/createEvent',
  async (payload) => {
    const eventCreated = await api.event.createEvent({
      data: payload,
    });
    return eventCreated.data.createEvent;
  }
);

export const deleteEventById = createAsyncThunk(
  'events/deleteEventById',
  async (eventId) => {
    const eventDeleted = await api.event.deleteEventById({ id: eventId });
    return eventDeleted.data.deleteEventById;
  }
);

export const updateEventById = createAsyncThunk(
  'events/updateEventById',
  async (payload) => {
    const { id, data } = payload;
    const eventUpdated = await api.event.updateEventById({
      id,
      data,
    });

    return eventUpdated.data.updateEventById;
  }
);

export const getEventById = createAsyncThunk(
  'devices/getEventById',
  async (payload) => {
    const { id } = payload;

    const response = await api.event.getEventById({ id });

    return response.data.getEventById;
  }
);

export const getEventsByIds = createAsyncThunk(
  'events/getEventsByIds',
  async (payload) => {
    const { eventIds } = payload;

    const response = await api.event.getEventsByIds({ eventIds });

    return response.data.getEventsByIds;
  }
);
